import { render, staticRenderFns } from "./DefaultHeader.DropdownAccount.vue?vue&type=template&id=71dcd7ba"
import script from "./DefaultHeader.DropdownAccount.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.DropdownAccount.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeader.DropdownAccount.vue?vue&type=style&index=0&id=71dcd7ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports